import axiosInstance from "../../utils/axiosConfig";
import { compactParams } from "../../lib/api/params";
import type { IsoDateRange } from "../../lib/adminExport/datePresets";

export const PAYROLL_EXPORT_PAGE_LIMIT = 100;
export const MAX_PAYROLL_EXPORT_PAGES = 300;

/** Pages through paid payroll records at a safe limit for CSV export. */
export async function fetchPayrollActivitiesForExport(
  range?: IsoDateRange | null
): Promise<any[]> {
  const records: any[] = [];
  let totalPages = 1;

  for (let page = 1; page <= totalPages; page++) {
    if (page > MAX_PAYROLL_EXPORT_PAGES) {
      throw new Error(
        `Export is limited to ${
          MAX_PAYROLL_EXPORT_PAGES * PAYROLL_EXPORT_PAGE_LIMIT
        } rows. Narrow your date range.`
      );
    }

    const { data } = await axiosInstance.get<{ data?: unknown }>("api/payroll", {
      params: compactParams({
        page,
        limit: PAYROLL_EXPORT_PAGE_LIMIT,
        status: "paid",
        startDate: range?.startDate,
        endDate: range?.endDate,
      }),
    });

    const root = (data?.data ?? {}) as {
      records?: any[];
      pagination?: { totalPages?: number };
    };
    const batch = Array.isArray(root.records) ? root.records : [];

    if (page === 1) {
      totalPages = Math.max(1, root.pagination?.totalPages ?? 1);
    }

    records.push(...batch);
    if (batch.length === 0) break;
  }

  return records;
}
